import { bindForm } from 'utils'
import { login } from 'user'

const Page = {
  oninit({ state, attrs: { email } }) {
    state.vm = { user: { email } }
  }
  , view({ state }) {
    const { sent, loading, user: { email } } = state.vm
    return !sent
      ? m.fragment({ key: 'login' }, [
        m('form', {
            oninput: bindForm(state, { path: [ 'user' ] })
            , onsubmit: (e) => {
              e.preventDefault()
              state.vm = i.set(state.vm, 'loading', true)
              login(state.vm.user)
                .then( () => state.vm = i.assign(state.vm, { sent: true }))
                .catch( (err) => alert(err.message || err)) // TODO FINDME
                .finally( () => {
                  state.vm = i.assign(state.vm, { loading: false })
                  m.redraw()
                })
            }
          }
          , m('h4', `Enter your email to get started`)
          , m('input', { class: 'form-input', name: 'email', id: 'email', type: 'email', required: true, placeholder: 'me@example.com', value: email || '' })
          , m('button', { class: 'btn', disabled: loading }, 'Login/register'))
        , m('h4', `Don't have your own email address?`)
        , m('p', `That's fine, ask your parent or guardian for help :-)`)
        , m('h4', 'Why do you need an email address?')
        , m('p', 'Short answer, to ensure we can get in touch with you.')
        , m('p', 'Long answer, TODO...')
      ])
      : m('div'
        , { key: 'confirmation' }
        , m('p'
          , m('h4', 'Login link on its way.')
          , `An email login is on its way to "${email}".`
          , m('br')
          , 'Go check your email and then we can continue :-)')
          , m('h4', m('i', `Didn't get an email?`))
          , `Double check your spam filter, and check that you've typed everything correctly.`
          , m('br')
          , 'Need to try again? ', m('button', { class: 'btn btn-link', onclick: () => state.vm = i.assign(state.vm, { sent: false }) }, 'Click here'))
  }
}

export const LoginPage = Page

export default Page
